import { useUsableNetBannerHeight } from '../useUsableNetBannerHeight';
import { useUsableNetScrolling } from '../useUsableNetScrolling';

/**
 * Returns the offset for the usable net banner, when enabled and not scrolled.
 */
export const useUsableNetBannerOffset = () => {
  const { isScrolled } = useUsableNetScrolling();
  const usableNetBannerHeight = useUsableNetBannerHeight();

  return isScrolled ? 0 : usableNetBannerHeight;
};
